import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { number } from 'ng-brazil/number/validator';
import { Auth } from 'src/app/models/auth';
import { Solicitation } from 'src/app/models/card-solicitation';
import { FilterCardSolicitation } from 'src/app/models/relatorio';
import { SolicitationRequest } from 'src/app/models/request/card-solicitation-request';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CardSolicitationService } from 'src/app/services/card-solicitation.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import {saveAs} from 'file-saver';
import { DatePipe } from '@angular/common';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';

@Component({
  selector: 'app-situacao-solicitacao-cartao',
  templateUrl: './situacao-solicitacao-cartao.component.html',
  styleUrls: ['./situacao-solicitacao-cartao.component.css']
})
export class SituacaoSolicitacaoCartaoComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
    private authenticationService: AuthenticationService,
    private relatorioService: RelatorioService
  ) { }

  private currentUser: Auth;
  public cardSolicitation: any;
  public filtroOn: boolean = false;
  public queryDate: Date;
  public filtro = new FilterCardSolicitation(null,null,null);
  public dataInicio = new Date();
  public dataFim = new Date();
  public dataMaxima = new Date();
  public statusCtrl: FormControl = new FormControl();

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    
    this.dataInicio.setDate(this.dataInicio.getDate()-90);
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.carregarRelatorio(1);
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getCardSolicitation(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.cardSolicitation = response.result.cardSolicitation;
        this.totalItems = response.result.total;     
        this.queryDate = new Date();        
      }
    });
  }

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  } 
  
  setPeriod(inicio,date: Date){
    date = new Date(date)
    if(inicio){
      this.filtro.dateStart = date;
      this.dataMaxima = new Date(date.getFullYear(), date.getMonth(), date.getDate()+90);
      if (this.filtro.dateEnd >= this.dataMaxima){
        this.filtro.dateEnd = this.dataMaxima;
      } else if (this.filtro.dateEnd < this.filtro.dateStart){
        this.filtro.dateEnd =  this.filtro.dateStart;
      }
    } else {
      this.filtro.dateEnd = date;
    }
  }

  applyFilter() {
    this.filtro.status = this.statusCtrl.value ? +this.statusCtrl.value : null; 

    if(
      this.filtro.dateStart == null &&
      this.filtro.dateStart == null &&
      this.filtro.status == null
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    }
  }

  deleteFilter(){
    this.filtroOn = false;
    this.filtro = new FilterCardSolicitation(this.dataInicio,this.dataFim,null);

    this.dataMaxima = this.dataFim;

    this.filtroOn = false;

    this.carregarRelatorio(1);
  }

  getStatus(status){
    switch (status) {
      case 1:
        return 'Em análise';
      case 2:
        return 'Em Processamento';
      case 3:
        return 'Concluído';
      case 4:
        return 'Cancelado';
    }
  }
 
  exportExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'solicitacoes_cartao_elo_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['Número do Pedido','Quantidade','Data do Pedido','Data de Entrega','Situação do Pedido'];
    ws.WorksheetRows = [];
    // /*
    this.relatorioService.getCardSolicitation(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.cardSolicitation;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.solicitationId);
          lr.push(r.quantity);
          lr.push(this.datepipe.transform(r.solicitationDate, 'dd/MM/yyyy HH:mm'));
          lr.push(r.deliveryDate ? this.datepipe.transform(r.inclusionDate, 'dd/MM/yyyy') : null);
          lr.push(r.statusDescription);
          ws.WorksheetRows.push(lr);
        });

       worksheets.push(ws);

        // let filter = '';
        // filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText : ''
        
        excelService.generateExcelReport('Solicitações de cartões Bankei', worksheets, null).xlsx
        .writeBuffer().then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error('Ocorreu um erro ao paginar relatorio');
    });
  }

exportPdf(){
  let result = [];
  let date: any = new Date();
  date = date.toLocaleDateString('pt-BR');
  date = date.split('/');

  const pdfData = new PdfData();
  pdfData.PdfTitle = 'solicitacoes_cartao_elo_' + date[2] + '-' + date[1] + '-' + date[0];
  pdfData.PdfHeaders = ['Número do Pedido','Quantidade','Data do Pedido','Data de Entrega','Situação do Pedido'];
  pdfData.PdfRows = [];
  
  this.relatorioService.getCardSolicitation(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
  .subscribe(response => {
    if (response.status === ApiError.Sucesso) {
      result = response.result.cardSolicitation;
    
      result.forEach((r) => {
        const lr = new Array<string>();
        lr.push(r.solicitationId);
        lr.push(r.quantity);
        lr.push(this.datepipe.transform(r.solicitationDate, 'dd/MM/yyyy HH:mm'));
        lr.push(r.deliveryDate ? this.datepipe.transform(r.inclusionDate, 'dd/MM/yyyy HH:mm') : null);
        lr.push(r.statusDescription);
        pdfData.PdfRows.push(lr);
      });

      let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');
      filter += this.filtro.status ? ' - Situação: ' + this.getStatus(this.filtro.status) : ''
      
      const pdfService = new PdfService();
      pdfService.generatePdfReport('Solicitações de cartões Bankei',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss')).getBlob((blob) => {
        saveAs(blob, pdfData.PdfTitle + '.pdf');
      });

    } else {
      this.alertService.error(response.message);
    }
  },
  error => {
    this.alertService.error(
      'Ocorreu um erro ao paginar o relatorio'
    );
  });
}
}
